import React from "react";
import { CreditReportProductDetail, CreditReportProductList } from "./CreditReportProductList";

type Props = {
	creditReportList: CreditReportProductDetail[]; 
	children?: React.ReactNode;
}

export const CreditReportSetting: React.FunctionComponent<Props> = ({ creditReportList, children }) => {
	return (
		<div className='credit-report-section'>
			<h4>Manage Credit Report Products</h4>
			{children}
			{creditReportList.length > 0 && (<CreditReportProductList list={creditReportList} />)}
			{creditReportList.length <= 0 && (<p>No credit report products available</p>)}
		</div>
	)
}